// extracted by mini-css-extract-plugin
var _1 = "_reports-module__button-container";
var _2 = "_reports-module__tab-display";
var _3 = "_reports-module__title";
export { _1 as "button-container", _2 as "tab-display", _3 as "title" }
